import { render, staticRenderFns } from "./MyTodoList.vue?vue&type=template&id=dee96f0a&scoped=true&"
import script from "./MyTodoList.vue?vue&type=script&lang=js&"
export * from "./MyTodoList.vue?vue&type=script&lang=js&"
import style0 from "./MyTodoList.vue?vue&type=style&index=0&id=dee96f0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee96f0a",
  null
  
)

export default component.exports